// MyLabs.tsx
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../../Component/DigitalMarketing/SearchBox";
import { useDispatch } from "react-redux";
import { Change } from "../../../../store/async-actions/digitalmarketing/header";
import DashTable from "./DashTable";
import Pagination from "../../../../Component/DigitalMarketing/Pagination";
import MyLabsDetails from "./MyLabsDetails";
import DashTabs from "./DashTabs";
import { useGetMyLabsListQuery } from "../../../../Service/LabManagement";
import { useGetAllBranchesQuery } from "../../../../Service/Masters";
import useSnackbar from "../../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../../Component/DigitalMarketing/Toast";
import Loader from "../../../../Component/DigitalMarketing/Loader";

const MyLabs = () => {
  const [updateData, setUpdateData] = useState<any>(null);
  const [show, setShow] = useState(false);
  const [view, setView] = useState(false);
  const [pagination, setPagination] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [deleted, setDeleted] = useState(false);
  const { open, message, openSnackBar, type } = useSnackbar();

  const dispatch = useDispatch();
  const { data: branchOptions } = useGetAllBranchesQuery({
    refetchOnMountOrArgChange: true,
  });
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const {
    data: MyLabData,
    isLoading,
    refetch,
  } = useGetMyLabsListQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    setPagination(1);
  }, [searchValue]);

  useEffect(() => {
    const data: any = {
      first: "My Labs"
    };
    dispatch(Change(data));
  }, [show, updateData, view, dispatch]);
  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <div>
      <Toast open={open} type={type} message={message} />
      <Row>
        <Col md={5}>
          <SearchBox value={searchValue} onChange={onChangeSearch} />
        </Col>
        <Col md={7} className="d-flex justify-content-end">
          <DashTabs
            setShow={setShow}
            show={show}
            setUpdateData={setUpdateData}
            setView={setView}
          />
        </Col>
      </Row>
      <div className="row">
        <div className={show ? "col-8" : "col-12"}>
          <DashTable
            list={MyLabData}
            setShow={setShow}
            setUpdateData={setUpdateData}
            setView={setView}
            deleted={deleted}
            setDeleted={setDeleted}
            refetch={refetch}
          />
        </div>
        {show && (
          <div className="col-4" style={{ backgroundColor: "white" }}>
            <MyLabsDetails
              updateData={updateData}
              view={view}
              setShow={setShow}
              branchOptions={branchOptions}
              refetch={refetch}
            />
          </div>
        )}
        <Pagination
          setPagination={setPagination}
          pagination={pagination}
          data={MyLabData}
        />
      </div>
    </div>
  );
};
export default MyLabs;
